export default __webpack_public_path__ + "static/media/time_red.cb89c4e2.svg";